import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { getOrders } from '../getOrders';
import useIonicToast from '../../../hooks/useIonicToast';
import { useQueryParams } from '../../../hooks/updateQueryParams';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { OrderStatusType } from '../../../types/order/orderType';

export default function useStoreOrdersService() {
  const { presentIonToast } = useIonicToast();
  const { authToken, storeId } = useSelector((state: RootState) => ({
    authToken: state.userSession.signedAccessToken,
    storeId: state.userStores.activeStore?.id,
  }));
  const [filters, setFilters] = React.useState<{
    product_id?: string;
    status?: OrderStatusType;
    // search?: string;
  }>({});
  useQueryParams(filters);

  const ordersQuery = useQuery({
    queryKey: ['orders', filters],
    queryFn: async () => {
      if (!storeId || !authToken) return;
      try {
        const orders = await getOrders(storeId, authToken, filters);
        return orders.orders;
      } catch (error: any) {
        presentIonToast(error.message, 'error');
      }
    },
    enabled: Boolean(authToken) && Boolean(storeId),
  });

  const applyFilter = (name: keyof typeof filters, value: string) => {
    setFilters((prev) => {
      const { [name]: _, ...res } = prev;
      if (value.toLowerCase() === 'all') return { ...res };
      return { ...res, [name]: value };
    });
  };

  return {
    ordersQuery,
    applyFilter,
    filters,
  };
}
